import {GAME_ID, IS_BACKDOOR} from "modules/constants";
import RallySSO from "modules/utils/SSO/rallySSO";
import {get} from "lodash-es";
import {deeplinkOrWebRedirect} from "modules/utils/mlbConfig";
import CONSTANTS from "modules/utils/constants";

export enum SSOErrors {
	UNDER21 = "under_21",
	NO_DATE = "no_date",
}

export enum SSOType {
	RALLY = "rally",
	WEB = "web",
	QUICK_PICK = "quick_pick",
}

interface IMlbOktaError {
	redirect: boolean;
	message: {
		errorCode: "login_required";
		errorSummary: string;
		name: string;
	};
}

export class SSO {
	static readonly IS_BACKDOOR_MODE = IS_BACKDOOR;
	static readonly GAME_ID_DATA = GAME_ID;
	private static BASE_DOMAIN = import.meta.env.VITE_BASE_DOMAIN || "";
	private static BASE_URL = import.meta.env.VITE_BASE_URL || "";

	private uuid: string = "";
	private platform: string = "web";
	private type: SSOType = SSOType.WEB;
	private error: SSOErrors | null = null;


	public static readonly TO_GAME_REDIRECT = () => {
		deeplinkOrWebRedirect(
			`${SSO.BASE_DOMAIN}/play?redirectUrl=${SSO.BASE_DOMAIN}${SSO.BASE_URL}&gameId=${SSO.GAME_ID_DATA}`
		);
	};
	/**
	 * SSO for APP, initialized when `isNative=true`
	 */
	public async initRallySSO() {
		const mlbApi = new RallySSO();

		window.logger.push("init");
		await mlbApi.init();
		window.logger.push("initialize");

		await new Promise((resolve) => {
			void mlbApi.initialize(() => {
				window.logger.push("Event fired callback");
				const eventOnRallySSOReady = new CustomEvent("onRallySSOReady");
				window.dispatchEvent(eventOnRallySSOReady);
				window.logger.push("getUser");
				const user = mlbApi.getUser();
				window.logger.push(`user: ${JSON.stringify(user)}`);
				const oktaId = get(user, "oktaId", undefined);
				window.logger.push(`oktaId: ${String(oktaId)}`);
				if (oktaId) {
					this.uuid = oktaId;
					this.type = SSOType.RALLY;
				} else {
					mlbApi.showAlert("Auth required");
					throw new Error(`Authentication Required`);
				}

				resolve(null);
			});
		});
	}

	/**
	 * SSO for WEB, initialized when `isNative=false`
	 */

	public async initWebAuthSSO() {
		// this.uuid = '00ue19t7xlCKMdBq2357';
		// this.platform = "web";
		// await Promise.resolve()
		try {
			if (!window.mlbOkta) {
				throw new Error("No mlb api found");
			}

			const result = await window.mlbOkta.isLoggedIn();
			const accessToken = get(result, "accessToken");
			const claims = get(accessToken, "claims");
			const uid = get(claims, "uid", "");

			if (!uid) {
				throw new Error("No credentials");
			}

			// this.token = token;
			this.uuid = uid;
			this.type = SSOType.WEB;
		} catch (e: unknown) {
			const error = e as IMlbOktaError;

			if (!error.redirect) {
				const errorMessage = get(error, "message");
				const message = get(errorMessage, "errorSummary", "Auth required");
				throw new Error(message);
			}

			// window.mlbOkta.redirectToLogin();
			// SSO.TO_PLAY_LOGIN_FORM();
			SSO.TO_GAME_REDIRECT();
		}
	}

	public getType() {
		return this.type;
	}

	public getError() {
		return this.error;
	}

	public toJSON() {
		return {
			platform: this.platform,
			uid: this.uuid,
		};
	}
}

export function closeApplication() {
	if (RallySSO.IS_NATIVE) {
		RallySSO.nativeBridge?.close();
	} else {
		window.location.href = CONSTANTS.EXIT_URL;
	}
}
